import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LiveShowStructuredData from 'components/VideoPlayer/LiveShowStructuredData';
import JWVideoPlayer from 'components/JWVideoPlayer';
import ErrorAlert from 'components/ErrorAlert';

const PlayerErrorWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
`;

LiveVideoPlayer.propTypes = {
  autoplay: PropTypes.oneOf([false, true, 'muted', 'play', 'any']),
  file: PropTypes.string,
  libraryUrl: PropTypes.string,
  live: PropTypes.bool,
  onSuccess: PropTypes.func,
  settingsLoading: PropTypes.bool,
};

function LiveVideoPlayer({ autoplay, file, libraryUrl, live, onSuccess, settingsLoading }) {
  const hasError = !settingsLoading && (!file || !libraryUrl);

  return (
    <>
      <LiveShowStructuredData />
      {hasError ? (
        <PlayerErrorWrapper>
          <ErrorAlert>Live video is temporarily unavailable.</ErrorAlert>
        </PlayerErrorWrapper>
      ) : (
        <JWVideoPlayer
          autoplay={autoplay}
          file={file}
          libraryUrl={libraryUrl}
          live={live}
          onSuccess={onSuccess}
          settingsLoading={settingsLoading}
        />
      )}
    </>
  );
}

export default React.memo(LiveVideoPlayer);
